import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import logos from './logos.svg';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './DealsHeader.module.scss';

import { usePollingStatus } from '@hotels-hotel-detail/data-access/hooks/useHotelOffersContext';
import SectionHeader from '@hotels-hotel-detail/ui/SectionHeader';
import FormattedMessage from '@shared/ui/components/i18n/FormattedMessage';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
};
const cls = cssModules(STYLES);
const DealsHeader = ({ i18n }: Props) => {
  const isFinished = usePollingStatus();
  return (
    <div className={cls('DealsHeader')}>
      <SectionHeader
        title={i18n.translate('ktxt_Compare_RoomAndPrices_Label')}
      />
      <div className={cls('DealsHeader__desc')}>
        <BpkText textStyle={TEXT_STYLES.base}>
          <FormattedMessage label="ktxt_Compare_RoomAndPrice_desc_Label" />
        </BpkText>
        {isFinished && (
          <img src={logos} alt="logos" className={cls('DealsHeader__img')} />
        )}
      </div>
    </div>
  );
};

export default withI18n(DealsHeader);
